import React from 'react';

// Investment Focus - Business Models. 56x56 gradient-bordered tile (the frame is
// part of the artwork), glyph exactly as Figma drew it. Gradient ids are
// per-instance (useId) so several icons on one page don't share ids and break.
const GRADIENT_STOPS = (
  <>
    <stop stopColor="#7458F6" />
    <stop offset="1" stopColor="#84AEF8" />
  </>
);

const WINDOWS = [
  { key: 2, x: '23.5', y: '21.5' },
  { key: 3, x: '29.5', y: '21.5' },
  { key: 4, x: '23.5', y: '26.5' },
  { key: 5, x: '29.5', y: '26.5' },
  { key: 6, x: '23.5', y: '31.5' },
  { key: 7, x: '29.5', y: '31.5' },
];

const BusinessModelsIcon = ({ size = 56 }) => {
  const uid = React.useId();
  const g = (n) => `business_models_${uid}_${n}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="0.5" y="0.5" width="55" height="55" rx="11.5" stroke={`url(#${g(0)})`} />
      <rect x="19" y="17" width="18" height="22" rx="1" stroke={`url(#${g(1)})`} strokeWidth="2" />
      {WINDOWS.map((w) => (
        <rect
          key={w.key}
          x={w.x}
          y={w.y}
          width="2"
          height="2"
          stroke={`url(#${g(w.key)})`}
        />
      ))}
      <defs>
        <linearGradient id={g(0)} x1="28" y1="0" x2="28" y2="56" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(1)} x1="28" y1="16" x2="28" y2="40" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(2)} x1="24.5" y1="21" x2="24.5" y2="24" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(3)} x1="30.5" y1="21" x2="30.5" y2="24" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(4)} x1="24.5" y1="26" x2="24.5" y2="29" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(5)} x1="30.5" y1="26" x2="30.5" y2="29" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(6)} x1="24.5" y1="31" x2="24.5" y2="34" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(7)} x1="30.5" y1="31" x2="30.5" y2="34" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
      </defs>
    </svg>
  );
};

export default BusinessModelsIcon;
